<div class="container-fluid py-3">
  <div class="row">

    @if (moduleDisabled) {
      <div class="col-12 mb-3">
        <div class="alert alert-warning d-flex align-items-center gap-2 mb-0" role="alert">
          <i class="material-icons">info</i>
          <div>
            El módulo de amonestaciones no está habilitado en este fraccionamiento.
            No se pueden registrar nuevas amonestaciones hasta que se habilite.
          </div>
        </div>
      </div>
    }

    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="noticeViolationService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '56rem' }"
        [value]="noticeViolationService.noticeViolations">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Amonestaciones
              </div>
              <div class="col-8 text-end">
                <button
                  (click)="create()"
                  [disabled]="moduleDisabled"
                  aria-label="Nueva amonestación"
                  title="Nueva amonestación"
                  class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>
                <button
                  (click)="noticeViolationService.getAll(neighborhoodId!)"
                  aria-label="Actualizar"
                  title="Actualizar"
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="houseLabel">
              Casa
              <p-sortIcon field="houseLabel"></p-sortIcon>
              <p-columnFilter type="text" field="houseLabel" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="title">
              Título
              <p-sortIcon field="title"></p-sortIcon>
              <p-columnFilter type="text" field="title" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="status">
              Estatus
              <p-sortIcon field="status"></p-sortIcon>
            </th>

            <th pSortableColumn="createdAt">
              Fecha
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>

            <th pSortableColumn="files.length">
              Archivos
              <p-sortIcon field="files.length"></p-sortIcon>
            </th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-noticeViolation>
          <tr class="p-selectable-row">
            <td>
              {{ noticeViolation.houseLabel }}
            </td>

            <td class="title-cell">
              {{ noticeViolation.title }}
            </td>

            <td>
              <span
                class="badge rounded-pill"
                [ngClass]="noticeViolation.status ? 'text-bg-success' : 'text-bg-secondary'">
                {{ noticeViolation.status ? 'Activa' : 'Inactiva' }}
              </span>
            </td>

            <td>
              {{ noticeViolation.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' : neighborhoodService.currentNeighborhood?.timeZone }}
            </td>

            <td>
              <span class="d-inline-flex align-items-center gap-1">
                <i class="material-icons text-secondary" style="font-size: 1.1rem;">attach_file</i>
                {{ noticeViolation.files.length }}
              </span>
            </td>

            <td class="text-nowrap">
              <button
                (click)="view(noticeViolation)"
                aria-label="Ver amonestación"
                title="Ver"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">visibility</i>
              </button>
              <button
                (click)="view(noticeViolation, true)"
                aria-label="Editar amonestación"
                title="Editar"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">edit</i>
              </button>
              <button
                (click)="delete(noticeViolation)"
                aria-label="Eliminar amonestación"
                title="Eliminar"
                class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center text-secondary py-4">
              No hay amonestaciones registradas.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
